<section>
  <ng-content></ng-content>
</section>
<section class="empty-state" *ngIf="showEmptyState">
  <p class="empty-state-info">
    <span>{{ emptyText }}</span>
  </p>
</section>
